import React from 'react';
import { FormSelectInput, theme } from '@superhi/design';
import countryList from 'country-list';
import { CardElement } from '@stripe/react-stripe-js';
import { FormField, Field } from '@superhi/design/dist/cjs/components/forms/inputs/Field';
import styled from 'styled-components';
import { styles } from '@superhi/design/dist/cjs/components/forms/inputs/Base';
import { ApolloError } from '@apollo/client';

countryList.overwrite([{
  code: 'GB',
  name: 'United Kingdom'
}, {
  code: 'US',
  name: 'United States'
}]);
var COUNTRY_OPTIONS = /*#__PURE__*/countryList.getData().sort(function (a, b) {
  return a.name.localeCompare(b.name);
}).map(function (country) {
  return {
    display: country.name,
    value: country.name
  };
});

var FormSelectInputCountry = function FormSelectInputCountry(props) {
  return React.createElement(FormSelectInput, Object.assign({}, props, {
    options: COUNTRY_OPTIONS
  }));
};

countryList.overwrite([{
  code: 'GB',
  name: 'United Kingdom'
}, {
  code: 'US',
  name: 'United States'
}]);
var COUNTRY_OPTIONS$1 = /*#__PURE__*/countryList.getData().sort(function (a, b) {
  return a.name.localeCompare(b.name);
}).map(function (country) {
  return {
    value: country.code,
    display: country.name
  };
});

var FormSelectInputCountryCode = function FormSelectInputCountryCode(props) {
  return React.createElement(FormSelectInput, Object.assign({}, props, {
    options: COUNTRY_OPTIONS$1
  }));
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject;
var Wrapper = /*#__PURE__*/styled.div(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n\n  display: flex;\n  align-items: center;\n\n  border-color: ", ";\n\n  > * {\n    width: 100%;\n  }\n"])), styles, function (_ref) {
  var $isFocused = _ref.$isFocused;
  return $isFocused ? theme.colors.BLUE_50 + "!important" : '';
});

var CARD_ELEMENT_OPTIONS = {
  hideIcon: false,
  style: {
    base: {
      fontSize: '16px',
      color: theme.colors.GREY_90,
      // padding: '20px',
      backgroundColor: theme.colors.WHITE,
      fontSmoothing: 'inherit',
      fontFamily: 'GT America',
      '::placeholder': {
        color: theme.colors.GREY_50
      }
    },
    invalid: {
      color: theme.colors.RED_50
    }
  }
};

var FormStripeInput = function FormStripeInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      required = _ref.required;

  var _React$useState = React.useState(false),
      isFocused = _React$useState[0],
      setIsFocused = _React$useState[1];

  return React.createElement(FormField, {
    name: name,
    label: label
  }, function (_ref2) {
    var field = _ref2.field,
        error = _ref2.error,
        _ref2$disabled = _ref2.disabled,
        disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
        helpers = _ref2.helpers,
        id = _ref2.id;
    return React.createElement(Field, {
      id: id,
      error: error,
      label: label,
      required: required
    }, React.createElement(Wrapper, Object.assign({}, field, {
      error: error,
      "$isFocused": isFocused
    }), React.createElement(CardElement, {
      onReady: function onReady() {
        helpers.setTouched(true);
      },
      onBlur: function onBlur() {
        setIsFocused(false);
      },
      onFocus: function onFocus() {
        setIsFocused(true);
        helpers.setTouched(true);
      },
      options: _extends({}, CARD_ELEMENT_OPTIONS, {
        disabled: disabled
      })
    })));
  });
};

var createErrorMap = function createErrorMap(e, fieldNameMap) {
  if (fieldNameMap === void 0) {
    fieldNameMap = {};
  }

  if (e instanceof ApolloError) {
    return e.graphQLErrors.reduce(function (acc, err) {
      var _extends2;

      var error = err;
      var fieldName = error.details;
      return _extends({}, acc, (_extends2 = {}, _extends2[fieldNameMap[fieldName] || fieldName] = err.message, _extends2));
    }, {});
  } else {
    return {};
  }
};
var setErrorsFromApollo = function setErrorsFromApollo(setFieldError, e, fieldNameMap) {
  if (e instanceof ApolloError) {
    var firstFieldName;
    e.graphQLErrors.forEach(function (err, i) {
      var error = err;
      var fieldName = error.details;

      if (i === 0) {
        firstFieldName = fieldName;
      }

      setFieldError(fieldNameMap ? fieldNameMap[fieldName] : fieldName || fieldName, err.message);
    });

    if (firstFieldName) {
      var _document$querySelect;

      var el = (_document$querySelect = document.querySelector("[name=\"" + firstFieldName + "\"]")) == null ? void 0 : _document$querySelect.parentElement;

      if (el && (el == null ? void 0 : el.getBoundingClientRect().top) < 0) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  }
};
var SuperHiFormError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(SuperHiFormError, _Error);

  function SuperHiFormError(config) {
    var _this;

    _this = _Error.call(this, 'An error occurred.') || this;
    Object.setPrototypeOf(_assertThisInitialized(_this), (this instanceof SuperHiFormError ? this.constructor : void 0).prototype);
    _this.name = 'SuperHiFormError';
    _this.fields = config.fields;
    _this.genericMessage = config.genericMessage;
    return _this;
  }

  return SuperHiFormError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
SuperHiFormError.defaultErrorMessage = 'An error occurred. Please contact customer support.';

export { FormSelectInputCountry, FormSelectInputCountryCode, FormStripeInput, SuperHiFormError, createErrorMap, setErrorsFromApollo };
//# sourceMappingURL=utils.esm.js.map
